import * as Telecom from '@servicetitan/telecom-rtcs-client';
import getQueue from '../../lib/getQueue';
import log from '../../lib/log';
import { serviceState } from '../../lib/state';
import getQueues from '../../api/getQueues';

async function handleQueueAgentAdded(event: Telecom.QueueAgentAddedEvent) {
  const queue = getQueue(event.queueId);

  log('rtcs:queue:agent_added:' + queue?.name, event);

  if (!queue) {
    serviceState.queues = await getQueues();
    return;
  }

  queue.memberIds = [...queue.memberIds, event.agentId];
}

export default handleQueueAgentAdded;
